module.exports = "<router-outlet>\r\n  <!-- <span *ngIf=\"showLoader\" class=\"loading\"></span> -->\r\n</router-outlet> \r\n<div class=\"rightbox\" style=\"padding: 10px;\"> \r\n  <iframe src=\"http://3.108.116.250:9090/invoiceUploader\" style=\"height: calc(100vh - 110px);width: 100%;\" frameborder=\"0\"></iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/crm/kcc/invoice-uploader/invoice-uploader.component.html
// module id = ./src/app/crm/kcc/invoice-uploader/invoice-uploader.component.html
// module chunks = main